import { DateTime } from "luxon";
import { configureStore, createSlice } from "@reduxjs/toolkit";

interface State {
  nowUtc: number;
}

const initialState: State = {
  nowUtc: DateTime.utc().toMillis(),
};

const slice = createSlice({
  name: "app/time",
  initialState,
  reducers: {
    updateNowUtc(state) {
      state.nowUtc = DateTime.utc().toMillis();
    },
  },
});

const store = configureStore({
  reducer: {
    time: slice.reducer,
  },
});

export default slice.reducer;

export const { updateNowUtc } = slice.actions;
